export default "__VITE_ASSET__12a6cca6__"